module.exports = __webpack_public_path__ + "static/media/adrena-me.c2fc205b.svg";